import { render, staticRenderFns } from "./Gamification.vue?vue&type=template&id=77ae9b7c&"
import script from "./Gamification.vue?vue&type=script&lang=js&"
export * from "./Gamification.vue?vue&type=script&lang=js&"
import style0 from "./Gamification.vue?vue&type=style&index=0&id=77ae9b7c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports